/* eslint-disable no-restricted-syntax */
/* eslint-disable new-cap */
// const L = require('leaflet');
import L from 'leaflet';
import '@elfalem/leaflet-curve';

import 'leaflet-css'; // core leaflet css
import './lib/map.css'; // additional mapbox css

// const Flickity = require('flickity');
// require('@elfalem/leaflet-curve');

// import '../vendor/leaflet.geometryutil';
// import '../vendor/leaflet-arrowheads';
import 'leaflet-geometryutil';
import 'leaflet-arrowheads';
import { GestureHandling } from 'leaflet-gesture-handling';
import axios from 'axios';
import lazySizes from 'lazysizes';
import { Dialog } from './modal';
import { createDParousel } from './carousel';

const destinationMapEl = document.querySelector('#destinationMap');
const bodyElement = document.querySelector('body');
const mediaBreakPoint = '(min-width: 640px)';
const mq = window.matchMedia(mediaBreakPoint);

if (destinationMapEl) {
	L.Map.addInitHook('addHandler', 'gestureHandling', GestureHandling);

	const destinationMapContainerEl = destinationMapEl.closest('.location-map-container');
	const mapPopupModalContainer = document.querySelector('.map-popup-overlay');
	const locID = destinationMapContainerEl.getAttribute('data-location');
	const showPois = destinationMapContainerEl.getAttribute('data-pois');
	const hotelPos = destinationMapContainerEl.getAttribute('data-hotel');
	const mapZoomLevel = destinationMapContainerEl.getAttribute('data-zoom-level');
	const processedMarkers = [];
	const processedStopMarkers = [];
	const processedStopArrows = [];
	const hotelMarkers = [];
	let group = null;

	const contextKey = bodyElement.getAttribute('data-context-key');
	const accessToken = contextKey === 'theme-aa' ? 'pk.eyJ1IjoiYW1lcmljYW5hZmZhaXIiLCJhIjoiY2x5Y3ExMjN5MWhzMDJsc2FvMjBwNXhhNiJ9.uLidDNaTolRfWTsXAhIIYg' : 'pk.eyJ1IjoiY2FuYWRpYW5hZmZhaXIiLCJhIjoiY2xraWJ1cDIwMGhrMzNxbnliMGhleW9uaSJ9.rFgCaojBWpo-BW_35avESg';

	const destinationMap = L.map('destinationMap', {
		scrollWheelZoom: false,
		gestureHandling: true,
		zoomControl: true,
	}).setView([42.361, -71.0587], mapZoomLevel || '15');

	L.tileLayer(`https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=${accessToken}`, {
		attribution: '© <a href="https://www.mapbox.com/feedback/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
		tileSize: 512,
		zoomOffset: -1,
		minZoom: 3,
		maxZoom: 18,
	}).addTo(destinationMap);

	const YellowMarkerIcon = new L.icon({
		iconUrl: '/site/assets/images/yellow-marker.png',
		className: 'icon-active',
		iconSize: [44, 44],
		iconAnchor: [22, 44],
	});

	const BlueMarkerIcon = new L.icon({
		iconUrl: '/site/assets/images/blue-marker.png',
		iconSize: [58, 58],
		iconAnchor: [29, 58],
	});

	const HotelMarkerIcon = new L.icon({
		iconUrl: '/site/assets/images/hotel-map-marker.png',
		iconSize: [22, 22],
		iconAnchor: [11, 22],
	});

	if (!document.querySelector('#mapPopupModal')) {
		const tplMapPopupModal = document.getElementById('mapPopupModalTpl') ? document.getElementById('mapPopupModalTpl').content : null;
		const mapPopupModalNode = tplMapPopupModal.cloneNode(true);
		mapPopupModalContainer.appendChild(mapPopupModalNode);
	}

	let mapPopupModalObj = null;
	const relatedImageEl = mapPopupModalContainer.querySelector('.related-image');
	const dayTextEl = mapPopupModalContainer.querySelector('.day-text');
	const titleTextEl = mapPopupModalContainer.querySelector('.title-text');
	const introTextEl = mapPopupModalContainer.querySelector('.intro');
	const exploreBtnEl = mapPopupModalContainer.querySelector('.explore-button');

	let arrowheads;
	const drawArrowheads = (latlngs, map) => {
		if (arrowheads) {
			arrowheads.remove();
		}
		const ghost = L.polyline(latlngs).arrowheads({ frequency: 1, fill: true, yawn: 40, color: '#333333', size: '10px', lineJoin: 'miter', lineCap: 'square' }).addTo(map);
		arrowheads = ghost.getArrowheads();
		ghost.remove();
		arrowheads.addTo(map);
	};

	const fetchResults = (value, poisValue) => {
		return new Promise((resolve) => {
			const url = `/assets/components/canadianaffair/getDestinations.php?loc=${value}&pois=${poisValue}`;

			axios
				.get(url)
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					console.error(error);
				});
		});
	};

	if (destinationMapContainerEl.classList.contains('itinerary')) {
		const dayPlanCarouselBlockEl = destinationMapContainerEl.querySelector('.day-plan-carousel-block');
		const dayPlanCarousel = destinationMapContainerEl.querySelector('.day-plan-carousel-container');
		const dPCarousel = createDParousel(dayPlanCarousel);

		const dayPlanEls = destinationMapContainerEl.querySelectorAll('.day-plan');
		dayPlanEls.forEach((el, idx) => {
			const stoplat = el.getAttribute('data-latitude');
			const stoplng = el.getAttribute('data-longitude');
			const stopText = el.getAttribute('data-plan-day');
			let iconSrc = '/site/assets/images/stop-blue-marker.png';
			let zIndexOffset = 0;
			switch (idx) {
				case 0:
					iconSrc = '/site/assets/images/stop-green-marker.png';
					zIndexOffset = 1000;
					break;
				case dayPlanEls.length - 1:
					iconSrc = '/site/assets/images/stop-red-marker.png';
					zIndexOffset = 1000;
					break;
				default:
					zIndexOffset = 0;
					break;
			}

			if (stoplat && stoplng) {
				const markerObj = L.marker([stoplat, stoplng], {
					icon: L.divIcon({
						html: `<img src="${iconSrc}" alt="Marker" />`,
						iconSize: [58, 58],
						iconAnchor: [29, 58],
					}),
					autoPan: false,
					zIndexOffset,
					'data-stop': idx,
					'data-plan-day': stopText,
					'data-image': el.querySelector('.plan-day-image').getAttribute('data-src'),
					'data-title': el.querySelector('.plan-day-title').innerHTML,
					'data-description': el.querySelector('.plan-day-desc').innerHTML,
				});
				processedStopMarkers.push(markerObj);

				if (idx + 1 <= dayPlanEls.length - 1) {
					const nextStoplat = dayPlanEls[idx + 1].getAttribute('data-latitude');
					const nextStoplng = dayPlanEls[idx + 1].getAttribute('data-longitude');
					const midPointlat = (parseFloat(nextStoplat) + parseFloat(stoplat)) * 0.5;
					const midPointlng = (parseFloat(nextStoplng) + parseFloat(stoplng)) * 0.5;

					const curvedPath = L.curve(['M', [stoplat, stoplng], 'Q', [midPointlat, midPointlng], [nextStoplat, nextStoplng]], { color: '#333333', dashArray: '5, 5', weight: 2 }).addTo(destinationMap);
					const latlngs = curvedPath.trace([0, 0.5]);
					processedStopArrows.push(latlngs);
				}
			}
		});

		processedStopMarkers.forEach((obj) => {
			obj.on('click', function (event) {
				// event.preventDefault();
				// event.stopPropagation();

				const layer = event.target;

				if (mq.matches) {
					let windowPageYOffset = 0;
					windowPageYOffset = window.pageYOffset - (bodyElement.classList.contains('scrolling') ? 160 : 100);
					const elemDistanceToTop = windowPageYOffset + dayPlanCarouselBlockEl.getBoundingClientRect().top;
					window.scrollTo(0, elemDistanceToTop);
					const stopDay = layer.options['data-stop'];
					dPCarousel.select(stopDay);
				} else if (!mq.matches) {
					relatedImageEl.setAttribute('data-src', layer.options['data-image']);
					dayTextEl.classList.remove('hidden');
					dayTextEl.querySelector('span').innerHTML = `Day ${layer.options['data-plan-day']}`;
					titleTextEl.innerHTML = layer.options['data-title'];
					introTextEl.innerHTML = layer.options['data-description'];
					exploreBtnEl.classList.add('hidden');
					lazySizes.loader.unveil(relatedImageEl);

					mapPopupModalObj = new Dialog('#mapPopupModal', 'div', 'a', false, () => {
						relatedImageEl.classList.remove('ls-is-cached', 'lazyloaded');
						relatedImageEl.classList.add('lazyload');
						relatedImageEl.setAttribute('data-src', '');
						relatedImageEl.removeAttribute('src');
						dayTextEl.classList.add('hidden');
						dayTextEl.querySelector('span').innerHTML = '';
						titleTextEl.innerHTML = '';
						introTextEl.innerHTML = '';
						exploreBtnEl.classList.remove('hidden');
						exploreBtnEl.setAttribute('href', '#');
					});
				}
			});
		});

		if (processedStopArrows.length) {
			drawArrowheads(processedStopArrows, destinationMap);
			destinationMap.on('moveend', () => {
				drawArrowheads(processedStopArrows, destinationMap);
			});
		}
	}

	if (hotelPos) {
		const hotelLng = hotelPos.split(',')[0];
		const hotelLat = hotelPos.split(',')[1];

		if (hotelLat && hotelLng) {
			const markerObj = L.marker([hotelLat, hotelLng], { icon: HotelMarkerIcon, autoPan: false });
			hotelMarkers.push(markerObj);
		}
	}

	fetchResults(locID, showPois).then((data) => {
		const { cities, poi, provinces } = data;

		if (!destinationMapContainerEl.classList.contains('itinerary')) {
			if (cities) {
				cities.forEach((marker, idx) => {
					if (marker.lat && marker.lng) {
						const markerObj = L.marker([marker.lat, marker.lng], { icon: BlueMarkerIcon, marker, type: 'city', idx, autoPan: false });
						processedMarkers.push(markerObj);
					}
				});
			}

			if (provinces) {
				provinces.forEach((marker, idx) => {
					if (marker.lat && marker.lng) {
						const markerObj = L.marker([marker.lat, marker.lng], { icon: BlueMarkerIcon, marker, type: 'province', idx, autoPan: false });
						processedMarkers.push(markerObj);
					}
				});
			}
		}

		if (poi) {
			poi.forEach((marker, idx) => {
				if (marker.lat && marker.lng) {
					const markerObj = L.marker([marker.lat, marker.lng], { icon: YellowMarkerIcon, marker, type: 'poi', idx, autoPan: false });
					processedMarkers.push(markerObj);
				}
			});
		}

		processedMarkers.forEach((obj) => {
			obj.on('click', function (event) {
				const layer = event.target;
				const markerData = layer.options.marker;
				const markerType = layer.options.type;

				relatedImageEl.setAttribute('data-src', markerData.image);
				titleTextEl.innerHTML = markerData.pagetitle;
				introTextEl.innerHTML = markerData.introtext;
				if (markerType === 'poi') {
					exploreBtnEl.classList.add('hidden');
				} else {
					exploreBtnEl.setAttribute('href', markerData.url);
				}
				lazySizes.loader.unveil(relatedImageEl);

				mapPopupModalObj = new Dialog('#mapPopupModal', 'div', 'a', false, () => {
					relatedImageEl.classList.remove('ls-is-cached', 'lazyloaded');
					relatedImageEl.classList.add('lazyload');
					relatedImageEl.setAttribute('data-src', '');
					relatedImageEl.removeAttribute('src');
					titleTextEl.innerHTML = '';
					introTextEl.innerHTML = '';
					exploreBtnEl.classList.remove('hidden');
					exploreBtnEl.setAttribute('href', '#');
				});
			});
		});

		document.onkeyup = function (event) {
			const kCode = event.which || event.keyCode;
			if (kCode === 27) {
				event.stopPropagation();
				mapPopupModalObj.getOpenDialog.close();
			}
		};

		const combinedMarkers = [...processedMarkers, ...processedStopMarkers, ...hotelMarkers];
		if (combinedMarkers.length) {
			group = new L.featureGroup(combinedMarkers).addTo(destinationMap);
			if (mapZoomLevel) {
				destinationMap.setView(group.getBounds().getCenter(), mapZoomLevel, { padding: [58, 58], animate: false });
			} else {
				destinationMap.fitBounds(group.getBounds(), { padding: [58, 58] });
			}
		}
	});

	const resizeObserver = new window.ResizeObserver(() => {
		if (group) {
			if (mapZoomLevel) {
				destinationMap.setView(group.getBounds().getCenter(), mapZoomLevel, { padding: [58, 58], animate: false });
			} else {
				destinationMap.fitBounds(group.getBounds(), { padding: [58, 58] });
			}
		}
	});

	resizeObserver.observe(destinationMapContainerEl);
}

const destinationsHubContainerEls = document.querySelectorAll('.destinations-hub-container');
if (destinationsHubContainerEls.length) {
	for (const destinationsHubContainerEl of destinationsHubContainerEls) {
		const dhViewTriggers = destinationsHubContainerEl.querySelectorAll('.dh-view-trigger');

		for (const trigger of dhViewTriggers) {
			trigger.addEventListener('click', (event) => {
				const target = event.currentTarget;

				if (target.classList.contains('dh-view-trigger')) {
					event.preventDefault();
					event.stopPropagation();

					const isActive = target.classList.contains('active');
					const active = destinationsHubContainerEl.querySelector('.active');
					const targetedPanel = destinationsHubContainerEl.querySelector(`#${target.getAttribute('aria-controls')}`);

					if (active && active !== target) {
						active.classList.remove('active');
						const activedPanel = destinationsHubContainerEl.querySelector(`#${active.getAttribute('aria-controls')}`);
						activedPanel.setAttribute('hidden', '');
						activedPanel.setAttribute('aria-hidden', 'true');
					}

					if (!isActive) {
						target.classList.add('active');
						targetedPanel.removeAttribute('hidden');
						targetedPanel.removeAttribute('aria-hidden');

						if (targetedPanel.querySelector('.destinations-carousel')) {
							const dCarouselEls = targetedPanel.querySelector('.destinations-carousel');
							const dCarouselFlickity = Flickity.data(dCarouselEls);
							dCarouselFlickity.resize();
						}
					} else {
						target.classList.remove('active');
						targetedPanel.setAttribute('hidden', '');
						targetedPanel.setAttribute('aria-hidden', 'true');
					}
				}
			});

			trigger.addEventListener('keydown', (event) => {
				const target = event.currentTarget;
				const key = event.which.toString();
				// 33 = Page Up, 34 = Page Down
				const ctrlModifier = event.ctrlKey && key.match(/33|34/);

				if (target.classList.contains('dh-view-trigger')) {
					// Up/ Down arrow and Control + Page Up/ Page Down keyboard operations
					// 38 = Up, 40 = Down
					if (key.match(/38|40/) || ctrlModifier) {
						const index = dhViewTriggers.indexOf(target);
						const direction = key.match(/34|40/) ? 1 : -1;
						const { length } = dhViewTriggers;
						const newIndex = (index + length + direction) % length;

						dhViewTriggers[newIndex].focus();

						event.preventDefault();
					} else if (key.match(/35|36/)) {
						// 35 = End, 36 = Home keyboard operations
						switch (key) {
							// Go to first accordion
							case '36':
								dhViewTriggers[0].focus();
								break;

							// Go to last accordion
							case '35':
								dhViewTriggers[dhViewTriggers.length - 1].focus();
								break;
							default:
								break;
						}
						event.preventDefault();
					}
				}
			});

			trigger.addEventListener('focus', () => {
				destinationsHubContainerEl.classList.add('focus');
			});

			trigger.addEventListener('blur', () => {
				destinationsHubContainerEl.classList.remove('focus');
			});
		}
	}
}
